var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComunicaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 110.96 127.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.82,51.17A22.54,22.54,0,0,0,88.31,28.66H81.79V22.51A22.53,22.53,0,0,0,59.28,0H22.51A22.54,22.54,0,0,0,0,22.51V88.45A22.54,22.54,0,0,0,22.51,111h24.4v9.42h0s0,.1,0,.26v1.26c.14,2.47,1.21,6.9,7.31,5.18l43.9-18.29A22.55,22.55,0,0,0,111,88.45h-.14Zm-9.18,37.38c0,12.28-14.46,16.25-14.46,16.25L56,116.77v-11.1a3.81,3.81,0,0,0-3.78-3.81H47.42l-.09-.08H22.51A13.34,13.34,0,0,1,9.19,88.45V22.51A13.33,13.33,0,0,1,22.51,9.19H59.28A13.34,13.34,0,0,1,72.61,22.51v6.15H55A26.82,26.82,0,1,0,81.79,55.48V37.84h6.52a13.35,13.35,0,0,1,13.33,13.33Zm-29-50.71V55.48A17.64,17.64,0,1,1,55,37.84H72.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComunicaLogo);
export default __webpack_public_path__ + "static/media/comunica-logo.ba4af0dc15f1ddb52abe9ad57eab01cd.svg";
export { ForwardRef as ReactComponent };